<template>
  <div>
    <!--流程flow-->
    <div>
      <div id="block-flow">
        <ul class="flow">
          <li v-for="item in process" v-bind:key="item.text" v-bind:class="{active: item.isActive}">{{item.text}}</li>
        </ul>
      </div>
    </div>
    <div class="content_item">
      <div>
        <span class="content_title">{{title}}</span>
      </div>
      <div class="title_margin">
        <span class="content_item_title content_title">{{titleData}}</span>
      </div>
      <div class="content_margin" v-for="item in contentList" v-bind:key="item.text">
        <span class="content">{{item.title}}</span>
        <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span>
        <span  class="content">{{item.text}}</span>
      </div>
    </div>
    <div class="content_margin">
      <span style="font-weight: bold" class="content">{{refundTip}}</span>
    </div>
    <!--图形验证
    <div class="content_margin" style="display: flex; align-items: center;">
      <input type="text" width="100" v-model="captcha.code" class="input_captcha" v-bind:placeholder="captcha.title">
      <img v-bind:src="captcha.src" v-on:click="getCaptcha()" style="cursor: pointer;" >
    </div>-->
    <!--短信验证-->
    <!--<div class="content_margin" style="display: flex; align-items: center;">
      <input type="text" width="100" v-model="verficationData.tel" v-bind:placeholder="verfication.tel" class="input_captcha">
      <div class="content_pay_item img_captcha" v-on:click="getVerfication()" style="margin: 0; display: flex; align-items: center;justify-content: center;">
        <span style="color: white; text-align: center; display: inline-block">{{verficationBtn}}</span>
      </div>
      <div style="margin-left: 10px">
        <span>{{verfication.fillTip}}</span>
      </div>
    </div>
    <div class="content_margin">
      <input type="text" width="100" v-model="verficationData.code" v-bind:placeholder="verfication.text" class="input_captcha">
    </div>-->
    <!--<div>
      <button v-on:click="modify()">返回修改</button>
    </div>-->
    <div class="content_margin content_pay">
      <div v-for="item in payType" v-bind:key="item.channel" class="content_pay_item" v-on:click="item.donateMethod">
        <img v-bind:src="item.bg" class="content_pay_item_bg">
        <span class="content_pay_item_text">{{item.text}}</span>
      </div>
    </div>
    <modal name="loading-dialog" height="auto">
      <div>
        <div style="text-align: center; padding: 10px"><span>{{loadingTip.text}}</span></div>
      </div>
    </modal>
    <modal name="wechat-dialog" height="auto" @opened="afterOpened" @closed="afterClosed">
      <div style="display: flex; justify-content: center; flex-direction: column">
        <div class="dialog_wechat_text"><span>{{wechatDialogTitle}}</span></div>
        <div class="dialog_wechat_text">HK${{payData.amount}}</div>
        <div id="qrcode" ref="qrcode" class="dialog_qrcode">
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import wechatBg from '@/assets/weChatPay.jpg'
import unionBg from '@/assets/unionpay.jpg'
import paypalBg from '@/assets/paypal.jpg'
import {
  goToPay,
  queryOrder,
  getResponse,
  getVerfication,
  checkVerfiation
} from '@/api'
import QRCode from 'qrcode2'

export default {
  name: 'DonationStepTwo',
  data () {
    return {
      title: this.$route.params.resultTitle.text,
      titleData: this.$route.params.resultTitleDetail.text,
      qrcodeUrl: null,
      contentList: [
        {title: this.$route.params.itemList.title, text: this.$route.params.itemList.mtitle, value: this.$route.params.itemList.mvalue},
        {title: this.$route.params.money.title, text: this.$route.params.money.text, value: this.$route.params.money.value},
        {title: this.$route.params.receipt.title, text: this.$route.params.receipt.mvalue.text, value: this.$route.params.receipt.mvalue.value},
        {title: this.$route.params.name.mholder, text: this.$route.params.name.mvalue, value: this.$route.params.name.mvalue},
        {title: this.$route.params.company.mholder, text: this.$route.params.company.mvalue, value: this.$route.params.company.mvalue},
        {title: this.$route.params.phoneNumber.mholder, text: this.$route.params.phoneNumber.mvalue, value: this.$route.params.phoneNumber.mvalue},
        {title: this.$route.params.phoneAddress.mholder, text: this.$route.params.phoneAddress.mvalue, value: this.$route.params.phoneAddress.mvalue},
        {title: this.$route.params.address.mholder, text: this.$route.params.address.mvalue, value: this.$route.params.address.mvalue}
        /* {title: this.$route.params.registerNumber.mholder, text: this.$route.params.registerNumber.mvalue, value: this.$route.params.registerNumber.mvalue},
        {title: this.$route.params.registerPlace.mholder, text: this.$route.params.registerPlace.mvalue, value: this.$route.params.registerPlace.mvalue},
        {title: this.$route.params.registerDate.mholder, text: this.$route.params.registerDate.mvalue, value: this.$route.params.registerDate.mvalue},
        {title: this.$route.params.registerSign.mholder, text: this.$route.params.registerSign.mvalue, value: this.$route.params.registerSign.mvalue},
        {title: this.$route.params.country.mholder, text: this.$route.params.country.mvalue, value: this.$route.params.country.mvalue},
        {title: this.$route.params.passNumber.mholder, text: this.$route.params.passNumber.mvalue, value: this.$route.params.passNumber.mvalue},
        {title: this.$route.params.passGooff.mholder, text: this.$route.params.passGooff.mvalue, value: this.$route.params.passGooff.mvalue},
        {title: this.$route.params.passExpiry.mholder, text: this.$route.params.passExpiry.mvalue, value: this.$route.params.passExpiry.mvalue} */
      ],
      refundTip: this.$route.params.refundTip,
      verfication: this.$route.params.verfication,
      verficationTime: 130 + 300, // 手机 验证码倒计时 1分钟
      payType: [
        // {channel: 'creditcard', bg: visaBg, text: this.$route.params.donationBtn.text, donateMethod: this.visadonate},
        {channel: 'paypal', bg: paypalBg, text: this.$route.params.donationBtn.text, donateMethod: this.paypaldonate},
        {channel: 'union', bg: unionBg, text: this.$route.params.donationBtn.text, donateMethod: this.uniondonate},
        {channel: 'wechat', bg: wechatBg, text: this.$route.params.donationBtn.text, donateMethod: this.wechatdonate}
      ],
      loadingTip: {
        text: this.$route.params.loadingTip
      },
      unionTip: {
        text: this.$route.params.unionTip
      },
      payData: {
        token: null,
        project: this.$route.params.itemList.mvalue,
        amount: this.$route.params.money.value,
        //amount: 1,
        invoice: this.$route.params.receipt.mvalue.value,
        name: this.$route.params.name.mvalue,
        phone: this.$route.params.phoneNumber.mvalue,
        address: this.$route.params.address.mvalue,
        email: this.$route.params.phoneAddress.mvalue,
        channel: null,
        locale: this.$route.params.local,
        registeNumber: this.$route.params.registerNumber.mvalue,
        country: this.$route.params.country.mvalue,
        registerDate: this.$route.params.registerDate.mvalue,
        authName: this.$route.params.registerSign.mvalue,
        region: this.$route.params.registerPlace.mvalue,
        passportNumber: this.$route.params.passNumber.mvalue,
        passportStartDate: this.$route.params.passGooff.mvalue,
        passportExpiryDate: this.$route.params.passExpiry.mvalue,
        username: null
      },
      verficationData: {
        codeId: null, // 验证码id
        code: null, // 验证码,
        tel: null
      },
      verficationBtn: this.$route.params.verfication.btnText,
      verficationCanClick: true,
      mchNumber: null, // 订单号
      wechatDialogTitle: this.$route.params.wechatDialogTitle,
      process: [
        {text: this.$route.params.process[0].text, isActive: false},
        {text: this.$route.params.process[1].text, isActive: true},
        {text: this.$route.params.process[2].text, isActive: false},
        {text: this.$route.params.process[3].text, isActive: false}
      ],
      queryTimer: null,
      captcha: {
        src: null,
        code: null,
        tip: this.$route.params.captcha.tip,
        title: this.$route.params.captcha.title
      },
      token: null,
      timer: null
    }
  },
  mounted () {
    this.getToken()
  },
  methods: {
    getToken () {
      this.token = this.$cookies.get('token')
    },
    visadonate: function () {
      console.log('visa donate')
      this.payData.channel = 'creditcard'
      this.checkAndPay()
    },
    wechatdonate: function () {
      console.log('wechat donate')
      this.payData.channel = 'wechat'
      this.checkAndPay()
    },
    paypaldonate: function () {
      console.log('paypal donate')
      this.payData.channel = 'paypal'
      this.checkAndPay()
    },
    uniondonate: function () {
      console.log('union donate')
      if (this.payData.amount > 35000) {
        alert(this.unionTip.text)
      } else {
        this.payData.channel = 'union'
        this.checkAndPay()
      }
    },
    afterOpened: function (event) {
      this.makeQrCode(this.qrcodeUrl)
    },
    afterClosed: function (event) {
      console.log('modal closed')
      clearInterval(this.queryTimer)
    },
    async checkAndPay () {
      this.pay()
    },
    pay: function () {
      this.showLoading()
      this.payData.token = this.token
      this.payData.username = this.$cookies.get('name')
      getResponse(goToPay(this.payData), resData => {
        console.log('pay', resData)
        this.hideLoading()
        this.mchNumber = resData.data.mch_trade_no
        console.log('pay', resData.data)
        if (this.payData.channel === 'wechat') {
          this.qrcodeUrl = resData.data.code_content
          this.$modal.show('wechat-dialog')
          this.query(this.payData.token)
        } else {
          window.open(resData.data.code_content, '_self')
        }
      }, () => {
        this.hideLoading()
      })
    },
    showLoading: function () {
      this.$modal.show('loading-dialog')
    },
    query: function (token) {
      console.log('query now')
      let queryParams = {
        api_token: token,
        mch_trade_no: this.mchNumber
      }
      let lang = this.payData.locale
      this.queryTimer = setInterval(function () {
        getResponse(queryOrder(queryParams), response => {
          if (response.data.status === 'SUCCESS' || response.status === 'REFUND') {
            console.log('query success')
            let url = response.data.result_url + '?lang=' + lang
            window.open(url, '_self')
          } else {
            console.log('query error')
          }
          console.log('data', response)
        })
      }, 3000)
    },
    hideLoading: function () {
      this.$modal.hide('loading-dialog')
    },
    makeQrCode: function (url) {
      let qrcode = new QRCode('qrcode', {
        width: 200,
        height: 200,
        text: url
      })
    },
    modify: function () {
      this.$router.replace({
        name: 'stepone',
        params: {
          backparams: this.$route.params
        }
      })
    },
    // 获取手机验证码
    getVerfication () {
      if (!this.verficationCanClick) {
        return
      }
      console.log('获取手机验证码')
      let params = {
        api_token: this.token,
        tel: this.verficationData.tel
      }
      getResponse(getVerfication(params), (res) => {
        let data = res.data
        let codeId = data.codeId
        console.log('data', data, 'codeId', codeId)
        this.verficationData.codeId = codeId
        // 倒计时
        let count = this.verficationTime
        this.verficationBtn = count
        this.verficationCanClick = !this.verficationCanClick
        alert(this.verfication.sendTip)
        this.timer = setInterval(() => {
          count = count - 1
          this.verficationBtn = count
          if (count <= 0) {
            this.initVerfication()
          }
        }, 1000)
      }, () => {
        this.initVerfication()
      })
    },
    // 检查手机验证码
    async checkVerification () {
      console.log('检查手机验证码')
      if (this.verficationData.code == null || this.verficationData.code.trim() === '') {
        alert(this.verfication.tip)
        return false
      }
      if (this.verficationData.tel == null || this.verficationData.tel.trim() === '') {
        alert(this.verfication.telTip)
        return false
      }
      let params = {
        api_token: this.token,
        codeId: this.verficationData.codeId,
        code: this.verficationData.code,
        tel: this.verficationData.tel
      }
      return checkVerfiation(params).then(res => {
        let response = res.data
        let msg = response.msg
        let code = response.code
        if (code === '200') {
          // 验证成功恢复验证码按钮
          this.initVerfication()
          clearInterval(this.timer)
          return true
        } else {
          alert(msg)
          return false
        }
      })
    },
    // 初始化或恢复手机验证码
    initVerfication () {
      clearInterval(this.timer)
      this.verficationCanClick = true
      this.verficationBtn = this.verfication.btnText
      this.verficationData.codeId = null
    }
  },
  computed: {
  }
}
</script>

<style>
  .content{
    font-size: 1.2em;
  }
  .content_pay {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .content_pay_item_bg {
    /*transform: scale(0.8);*/
    zoom: 0.3;
  }
  .content_pay_item_text {
    font-size: 1em;
    color: white;
    display: block;
    margin-top: 6px
  }
  .dialog_wechat_text {
    font-size: 1.2em;
    text-align: center;
    margin-top: 10px;
  }
  .dialog_wechat {
    height: auto;
  }
  .dialog_qrcode {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 60px;
  }
  .input_captcha {
    margin-right: 10px;
    height: 80px;
    padding-left: 8px;
  }
  .img_captcha {
    width: 200px;
    height: 80px;
  }

  @media only screen and (min-width: 900px){
    .content{
      font-size: 1.2em; /*no*/
    }
    .img_captcha {
      width: 80px; /*no*/
      height: 20px; /*no*/
      text-align: center;
    }
    .input_captcha {
      margin-right: 10px; /*no*/
      height: 30px; /*no*/
      padding-left: 8px; /*no*/
    }
    .content_pay_item_bg {
      /*transform: scale(0.8);*/
      zoom: 0.3; /*no*/
    }
    .content_pay_item_text {
      font-size: 1em; /*no*/
      color: white;
      display: block;
      margin-top: 6px /*no*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DonationStepTwo.vue